import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const Footer = () => {
  const { settings } = useSettings();
  const year = new Date().getFullYear();

  const socials = [
    { icon: Facebook, url: settings.facebook, key: "facebook" },
    { icon: Instagram, url: settings.instagram, key: "instagram" },
    { icon: MessageCircle, url: settings.whatsapp, key: "whatsapp" },
    { icon: Twitter, url: settings.twitter, key: "twitter" },
  ].filter((s) => s.url);

  return (
    <footer className="bg-obsidian text-white/80 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <img src="/logo.png" alt="ChainSmart" className="h-16 w-auto rounded-sm mb-4" />
          <p className="text-sm leading-relaxed text-white/60 max-w-xs">
            {settings.about?.slice(0, 160)}
          </p>
          {socials.length > 0 && (
            <div className="flex gap-3 mt-5">
              {socials.map((s) => (
                <a
                  key={s.key}
                  href={s.url}
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-gold hover:text-gold transition-colors rounded-sm"
                  data-testid={`social-${s.key}`}
                >
                  <s.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          )}
        </div>

        <div>
          <h4 className="overline text-gold mb-4">Shop</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/catalogue" className="hover:text-gold transition-colors">All Chains</Link></li>
            <li><Link to="/catalogue?category=Gold" className="hover:text-gold transition-colors">Gold Chains</Link></li>
            <li><Link to="/catalogue?category=Silver" className="hover:text-gold transition-colors">Silver Chains</Link></li>
            <li><Link to="/catalogue?category=GP" className="hover:text-gold transition-colors">Gold Plated Chains</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-gold mb-4">Information</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-gold transition-colors">About Us</Link></li>
            <li><Link to="/policies?tab=shipping" className="hover:text-gold transition-colors">Shipping & Delivery</Link></li>
            <li><Link to="/policies?tab=returns" className="hover:text-gold transition-colors">Returns & Refunds</Link></li>
            <li><Link to="/policies?tab=terms" className="hover:text-gold transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/policies?tab=privacy" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-gold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            {settings.contact_phone && (
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-gold" /> {settings.contact_phone}</li>
            )}
            {settings.contact_email && (
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-gold" /> {settings.contact_email}</li>
            )}
            {settings.address && (
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-gold" /> {settings.address}</li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 text-xs text-white/50 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>© {year} {settings.business_name || "ChainSmart"}. All rights reserved.</span>
          <span>Genuine 9K Gold · Transparent Pricing · Secure Ordering</span>
        </div>
      </div>
    </footer>
  );
};
